import Vue from 'vue'
import config from '@/config/index'
import router from '@/router'
import moment from 'moment'

export default {
  namespaced: true,
  actions: {
    loadItems ({commit, state, getters}, pagination) {
      if(!pagination)
        return Promise.resolve({})
      return Vue.axios.get(config.serverURI + '/reports', { params: pagination })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js